import FormGroup from '~/components/form/FormGroup';
import { FormHorizontal } from '~/components/form/layout';
import ZodFieldTextarea from '~/components/zod/ZodFieldTextarea';
import ZodFieldCheckbox from '~/components/zod/ZodFieldCheckbox';
import ZodFieldInput from '~/components/zod/ZodFieldInput';

export default function MpiCustomerForm() {
  return (
    <FormGroup>
      <FormHorizontal name="discount_flyer_25" label="25 Flyer Discount ($)">
        <ZodFieldInput type="number" name="discount_flyer_25" />
      </FormHorizontal>
      <FormHorizontal name="discount_flyer_50" label="50 Flyer Discount ($)">
        <ZodFieldInput type="number" name="discount_flyer_50" />
      </FormHorizontal>
      <FormHorizontal name="discount_brochure_2_25" label="2 Page - 25 Brochure Discount ($)">
        <ZodFieldInput type="number" name="discount_brochure_2_25" />
      </FormHorizontal>
      <FormHorizontal name="discount_brochure_2_50" label="2 Page - 50 Brochure Discount ($)">
        <ZodFieldInput type="number" name="discount_brochure_2_50" />
      </FormHorizontal>
      <FormHorizontal name="discount_brochure_4_25" label="4 Page - 25 Brochure Discount ($)">
        <ZodFieldInput type="number" name="discount_brochure_4_25" />
      </FormHorizontal>
      <FormHorizontal name="discount_brochure_4_50" label="4 Page - 50 Brochure Discount ($)">
        <ZodFieldInput type="number" name="discount_brochure_4_50" />
      </FormHorizontal>
      <FormHorizontal name="discount_brochure_8_25" label="8 Page - 25 Brochure Discount ($)">
        <ZodFieldInput type="number" name="discount_brochure_8_25" />
      </FormHorizontal>
      <FormHorizontal name="discount_brochure_8_50" label="8 Page - 50 Brochure Discount ($)">
        <ZodFieldInput type="number" name="discount_brochure_8_50" />
      </FormHorizontal>
      <FormHorizontal name="discount_aerial_video" label="Aerial Video Discount ($)">
        <ZodFieldInput type="number" name="discount_aerial_video" />
      </FormHorizontal>
      <FormHorizontal name="discount_aerial_photo" label="Aerial Photo Discount ($)">
        <ZodFieldInput type="number" name="discount_aerial_photo" />
      </FormHorizontal>
      <FormHorizontal name="discount_photography" label="Photography Discount ($)">
        <ZodFieldInput type="number" name="discount_photography" />
      </FormHorizontal>
      <FormHorizontal name="discount_print" label="Order-Level Print (Flyer/Brochure) Discount ($)">
        <ZodFieldInput type="number" name="discount_print" />
      </FormHorizontal>
      <FormHorizontal name="discount_gas" label="Disable Travel Compensation">
        <ZodFieldCheckbox name="discount_gas" />
      </FormHorizontal>
      <FormHorizontal name="disable_bundle_discount" label="Disable Bundle Discounts">
        <ZodFieldCheckbox name="disable_bundle_discount" />
      </FormHorizontal>
    </FormGroup>
  );
}
